var map = {
	"./35.svg": 23497,
	"./36.svg": 97914,
	"./37.svg": 3179,
	"./38.svg": 88204,
	"./39.svg": 23661,
	"./40.svg": 34297,
	"./41.svg": 68904,
	"./42.svg": 50267,
	"./43.svg": 8298,
	"./44.svg": 63573,
	"./45.svg": 18644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68025;